'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

interface NotificationModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const NotificationModalContext = createContext<NotificationModalContextType | undefined>(undefined);

export const NotificationModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <NotificationModalContext.Provider
      value={{
        isOpen,
        openModal,
        closeModal,
      }}
    >
      {children}
    </NotificationModalContext.Provider>
  );
};

export const useNotificationModal = () => {
  const context = useContext(NotificationModalContext);
  if (context === undefined) {
    throw new Error('useNotificationModal must be used within an NotificationModalProvider');
  }
  return context;
};
